export default "__VITE_ASSET__B7w3T1ud__"